import request from '@/utils/request'

export function fetchBasicShopInfo() {
  //
  return new Promise((resolve, reject) => {
    request({
      url: '/basic',
      method: 'get'
    })
      .then(repsonse => {
        resolve(repsonse)
      })
      .catch(error => {
        reject(error)
      })
  })
}
